import styled from 'styled-components'

export const ConditionNumberColumn = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`
